import { Assets } from 'pixi.js'
import { createPreloader } from '@/scripts/ui/preloader'
import { bundles } from '@/scripts/config/assets'
import { processActivities } from './activityProcessor'
import { GlobalState } from '@/scripts/config/globalState'

export function preloadAssets(onComplete: () => void): void {
  const preloader = createPreloader()

  Object.entries(bundles).forEach(([name, assets]) => Assets.addBundle(name, assets))

  Assets.loadBundle(Object.keys(bundles), (progress: number) => {
    preloader.displayLoadProgress(progress)
  })
    .then((resources: Record<string, { rawActivities?: unknown }>) => {
      // Process activities and hide preloader when done
      const rawActivities = resources.data?.rawActivities
      if (Array.isArray(rawActivities)) {
        processActivities(rawActivities, () => {
          preloader.hide()
        })
      } else {
        console.warn('[preloadAssets] rawActivities not found or invalid in "data" bundle.')
        preloader.hide()
      }

      onComplete()
    })
    .catch((err) => {
      console.error('[preloadAssets] Failed to load bundles:', err)
      // Even on error, try to show the button
      try {
        preloader.hide()
      } catch (e) {
        console.error('[preloadAssets] Error hiding preloader on error:', e)
      }
      onComplete()
    })
}

export function preloadActivitiesOnly(onComplete: () => void): void {
  try {
    // register bundles (safe to call multiple times)
    Object.entries(bundles).forEach(([name, assets]) => Assets.addBundle(name, assets))
  } catch {
    // Ignore errors if bundles are already registered
  }

  // we KNOW the bundle is named "data" and contains "rawActivities"
  Assets.loadBundle('data')
    .then((resources: { rawActivities?: unknown }) => {
      const raw = resources?.rawActivities
      if (!raw || !Array.isArray(raw)) {
        console.warn('[preloadActivitiesOnly] rawActivities not found or invalid in "data" bundle.')
      } else {
        processActivities(raw)
      }
    })
    .catch((err) => {
      console.error('[preloadActivitiesOnly] Failed to load "data" bundle:', err)
    })
    .finally(() => onComplete())
}

export function ensureActivitiesReady(): Promise<void> {
  if (Array.isArray(GlobalState.activities) && GlobalState.activities.length > 0) {
    return Promise.resolve()
  }
  return new Promise<void>((resolve) => {
    preloadActivitiesOnly(() => resolve())
  })
}
